/* eslint-disable react-hooks/exhaustive-deps */
import { FormEvent, MouseEvent, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useUserService } from "../../services/users";
import { useLocation } from "react-router-dom";
import { TProcessStates } from "../../lib/types/general";
import { Spinner } from "./spinner";
import { PasswordInput } from "./password-input";

export const UserSignInModal = ({
    refSignInModal,
    handleSignInModalClose,
    handleSignInModalShow,
}: {
    refSignInModal: React.RefObject<HTMLDivElement>;
    handleSignInModalClose: () => void;
    handleSignInModalShow: () => void;
}) => {
    const userRef = useRef<any>();
    const errorRef = useRef<string>("");
    const [missingFieldsMessage, setMissingFieldsMessage] = useState("");
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [password, setPassword] = useState("");
    const { singInUser, logOutUser, resetPassword } = useUserService();
    const locationInfo = useLocation();
    const [forgotPass, setForgotPass] = useState(false);
    const [wrongEmail, setWrongEmail] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [workingState, setWorkingState] = useState<TProcessStates>("idle");

    const windowGlobal = window as any;

    const loginHandler = async (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        errorRef.current = "";
        setMissingFieldsMessage("");
        const user = userRef.current?.value?.trim();
        if (!user || !password) {
            setMissingFieldsMessage(!user && !password ? "Email and password are required." : `${!user ? "Email" : "Password"} is required.`);
            return;
        }

        setIsSigningIn(true);
        try {
            setWorkingState("working");
            await singInUser(user, password); //const userInfo = await singInUser(user, pwd)
            handleSignInModalClose();
            setWorkingState("done");
            setPassword("");
            if (userRef.current) userRef.current.value = "";
            handleSignInModalClose();
        } catch (error) {
            console.error(error);
            errorRef.current = "Invalid username or password";
            setWorkingState("error");
            logOutUser();
        } finally {
            setWorkingState("idle");
            setIsSigningIn(false);
        }
    };

    const handleForgotPassword = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        errorRef.current = "";
        setMissingFieldsMessage("");
        const emailConfirm = userRef.current?.value?.trim();
        setWrongEmail(false);
        const response = await resetPassword(emailConfirm);
        if (response) {
            setEmailSent(true);
            setForgotPass(true);
            return;
        }
        if (!response) {
            setWrongEmail(true);
            setForgotPass(true);
            return;
        }
    };

    useEffect(() => {
        if (locationInfo.pathname === "/logoutduetoinactivity") {
            setTimeout(() => {
                handleSignInModalShow();
            }, 1000);
        }
    }, [locationInfo.pathname]);

    useEffect(() => {
        return () => {
            if (windowGlobal.wwg_refSignInModal) {
                windowGlobal.wwg_refSignInModal.hide();
            }
        };
    }, []);

    const modalContent = (
        <div ref={refSignInModal} className="modal fade text-start">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">WinWinGo Login</h5>
                    </div>
                    {!!!forgotPass && (
                        <div className="modal-body">
                            <form>
                                <input type="hidden" name="_token" />
                                <div className="mb-3">
                                    <label className="form-label small fw-semibold text-primary ms-2" htmlFor="userNameInput">
                                        Email
                                    </label>
                                    <input ref={userRef} type="email" className="form-control input-lg" name="email" data-testid="user-input" />
                                </div>
                                <PasswordInput label="Password" value={password} onChange={setPassword} testId="password-input" />
                                <div className="mb-3">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id="remember" />
                                        <label className="form-check-label" htmlFor="remember">
                                            Remember me
                                        </label>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <p>
                                        {missingFieldsMessage ? (
                                            <span className="alert alert-warning d-block py-1 px-3" role="alert">
                                                <i className="fa-solid fa-circle-exclamation me-2"></i>
                                                {missingFieldsMessage}
                                            </span>
                                        ) : null}
                                        <span className="badge rounded-pill text-bg-danger px-3">{errorRef.current}</span>
                                    </p>
                                    <button data-testid="login-button" disabled={isSigningIn} onClick={loginHandler} className="btn btn-primary fw-bold w-100">
                                        {workingState === "working" ? <Spinner /> : "Login"}
                                    </button>
                                    <button type="button" className="btn btn-link mt-1 text-primary" onClick={() => setForgotPass(true)}>
                                        Forgot Your Password?
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    {!!forgotPass && (
                        <div className="modal-body">
                            <p>
                                {" "}
                                <strong> Reset Password </strong>
                            </p>
                            <form onSubmit={handleForgotPassword}>
                                {!!wrongEmail && (
                                    <p className="text-danger text-center">
                                        <strong>User not found</strong>
                                    </p>
                                )}
                                {!!!emailSent && (
                                    <>
                                        <input type="hidden" name="_token" />
                                        <div className="form-group">
                                            <label className="control-label">Please confirm your email address</label>
                                            <div>
                                                <input
                                                    ref={userRef}
                                                    type="email"
                                                    className="form-control input-lg mt-2"
                                                    name="email"
                                                    data-testid="user-input"
                                                />
                                            </div>
                                            <div className="text-end">
                                                <button className="btn btn-primary mt-3" type="submit">
                                                    Send Email
                                                </button>
                                                <button
                                                    className="btn btn-danger mt-3 ms-3"
                                                    type="button"
                                                    onClick={() => {
                                                        setForgotPass(false);
                                                        setWrongEmail(false);
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {!!emailSent && (
                                    <div className="form-group">
                                        <p className="text-wrap">
                                            <strong>Please check your email inbox</strong> and click on the link we sent you. <br /> If you don't see it there,
                                            it might have gone to your spam folder.
                                        </p>
                                        <div className="text-end">
                                            <button
                                                className="btn btn-primary"
                                                style={{ width: "7rem" }}
                                                type="button"
                                                onClick={() => {
                                                    setEmailSent(false);
                                                    setForgotPass(false);
                                                    handleSignInModalClose();
                                                }}
                                            >
                                                OK
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    return <>{createPortal(modalContent, document.body)}</>;
};

export const SignIn = ({ showSignInModalHandler }: { showSignInModalHandler: () => void }) => (
    <a
        href="/"
        onClick={(e) => {
            e.preventDefault();
            showSignInModalHandler();
        }}
    >
        <a href="#signin" className="nav-link nav-row text-center rounded-3 signin ms-2 px-3">
            Sign In
        </a>
    </a>
);

export const SignOut = ({ signOutHandler }: { signOutHandler: () => void }) => (
    <button
        className="nav-link nav-row text-center rounded-3 signin ms-2"
        onClick={(e) => {
            e.preventDefault();
            signOutHandler();
        }}
    >
        Sign Out
    </button>
);

export const SignInAndOut = () => {
    const { isLoggedIn, logOutUser } = useUserService();
    const refSignInModal = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;

    const handleSignInModalShow = () => {
        const showModal1 = () => {
            if (!refSignInModal.current) {
                setTimeout(() => {
                    showModal1();
                }, 100);
                return;
            }

            const modalInstance = windowGlobal.bootstrap.Modal.getOrCreateInstance(refSignInModal.current);
            if (modalInstance) {
                modalInstance.show();
            }
        };

        showModal1();
    };
    const handleSignInModalClose = () => {
        if (!refSignInModal.current) {
            setTimeout(() => {
                handleSignInModalClose();
            }, 100);
            return;
        }
        windowGlobal.bootstrap.Modal.getInstance(refSignInModal.current)?.hide();
    };
    return (
        <>
            <UserSignInModal refSignInModal={refSignInModal} handleSignInModalClose={handleSignInModalClose} handleSignInModalShow={handleSignInModalShow} />
            {isLoggedIn ? <SignOut signOutHandler={logOutUser} /> : <SignIn showSignInModalHandler={handleSignInModalShow} />}
        </>
    );
};
